/** @jsx jsx */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { forwardRef } from 'react'
import { css, jsx } from '@emotion/react';
import { Icon } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { MouseEventHandler } from 'react';

/**
 * One item in the legend
 * @param text the string to be displayed
 * @param color where color is the color to be displayed
 * @param mouseOver (key) => any
 * @param mouseOut () => any 
 * @returns 
 */
export const LegendItem = forwardRef<HTMLDivElement,LegendItemProps>(({
    text,color,mouseOver,mouseOut, enabled, onClick
},ref) => {
	const _onClick = (e) => {
		if(enabled && mouseOut) { //clicking to disable it, so if mouseOut exists should call that too
			mouseOut();
		}
		onClick(e);
	}
    return (
        enabled ?   <div    ref = {ref}
                            key = {text} 
                            className={"legendItem"} 
                            css={legendItemStyle}
                            onMouseOver={mouseOver ? ()=>mouseOver(text):null}
                            onMouseOut={mouseOut ? () => mouseOut():null}
                            onClick={_onClick}>
                        <div css={colorBoxStyle(color)}
                             className={'colorBox'}/>
                        <span className={"label"}>{text}</span>
                    </div>
                :   <div    ref = {ref}
														key = {text}
														className={"legendItem"}
                            css={legendItemStyle}
														onMouseOut={mouseOut ? () => mouseOut():null}
                            onClick={_onClick}>
                        <Icon icon={IconNames.DISABLE}
                              className={'colorBox'}
                              iconSize={20}/>
                        <span className={"label disabled"}>{text}</span>
                    </div>
    )
})

export interface LegendItemProps {
    text;
    color;
    enabled:boolean;
    mouseOver;
    mouseOut;
    onClick:MouseEventHandler
}

const colorBoxStyle = (color) => css`
    background-color: ${color};
`
const legendItemStyle = css`
    padding-right: 6px;
    padding-top: 3px;
    padding-bottom: 3px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    background-color: white;
    cursor:pointer;

    .label {
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}
    .colorBox {
        width:20px;
        height:20px;
        border-radius: 3px;
        margin-right: 5px;
        flex-shrink: 0;
    }
`
